import React, { useRef, useEffect } from "react";
import "./Services.css";
import { HiDesktopComputer } from "react-icons/hi";
import { FiDatabase } from "react-icons/fi";
import { AiOutlineApi } from "react-icons/ai";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { MdOutlineWebAsset } from "react-icons/md";
import { FaSitemap } from "react-icons/fa";
import { MdOutlineIntegrationInstructions } from "react-icons/md";

const Services = () => {
  const container = useRef(null);
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    const el = container.current;

    gsap.fromTo(
      ".service__head",
      { opacity: 0 },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
        },
      }
    );

    gsap.fromTo(
      ".service",
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.3,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
        },
      }
    );
  }, []);

  return (
    <section id="services" ref={container}>
      <div className="section__wrapper services__wrapper">
        <div className="section__header center">
          <h2 className="primary__title service__head">Мої послуги</h2>
          <p className="text__muted description">
            Я пропоную широкий спектр послуг, які допоможуть вам створити
            надійні та масштабовані веб-додатки. Завдяки моєму досвіду, я можу
            забезпечити ефективність, надійність та адаптацію ваших проектів до
            ваших потреб.
          </p>
        </div>

        <div className="services__group">
          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <MdOutlineWebAsset className="icon" />
              </div>
              <h3 className="title">Лендінг сторінки</h3>
            </div>
            <p className="text__muted description">
              Швидкі й ефективні сайти для просування продуктів або послуг
            </p>
          </article>

          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <FaSitemap className="icon" />
              </div>
              <h3 className="title">Корпоративні сайти</h3>
            </div>
            <p className="text__muted description">
              Сайти для компаній із декількома сторінками, розділами та блогом.
            </p>
          </article>

          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <HiDesktopComputer className="icon" />
              </div>
              <h3 className="title">Портфоліо та сайти-візитки</h3>
            </div>
            <p className="text__muted description">
              Персональні або професійні сайти для представлення себе чи бренду.
            </p>
          </article>

          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <AiOutlineApi className="icon" />
              </div>
              <h3 className="title">Розробка REST API</h3>
            </div>
            <p className="text__muted description">
              Створення масштабованих API для веб або мобільних додатків.
              Авторизація та безпека (JWT, session-based auth).
            </p>
          </article>

          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <FiDatabase className="icon" />
              </div>
              <h3 className="title">Повний цикл розробки (Full-stack)</h3>
            </div>
            <p className="text__muted description">
              Від створення оригінальної ідеї до реалізації та підтримки повного проекту.
            </p>
          </article>

          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <MdOutlineIntegrationInstructions className="icon" />
              </div>
              <h3 className="title">Автоматизаія та інтеграції</h3>
            </div>
            <p className="text__muted description">
              Інтеграція CRM, аналітики, платіжних систем, чат-ботів.
              Налаштування бекграундних задач (cron jobs, черги).
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Services;
